export const isEmpty = (val?: unknown[]) => {
	if (val === undefined || val.length === 0) {
		return true;
	} else {
		return false;
	}
};

export default isEmpty;
